module.exports = "/_next/static/images/family-748e05b0fc9356f0014f24223b04e778.png";